interface ExpandActionsProps {
  getInitiativeStructure: (ids?: string[]) => void;
  initiativeList: { _id: string }[];
  expandedNodes: string[];
  setExpandedNodes: React.Dispatch<React.SetStateAction<string[]>>;
}

export const ExpandActions = ({
  getInitiativeStructure,
  initiativeList = [],
  expandedNodes,
  setExpandedNodes,
}: ExpandActionsProps) => {
  const handleExpand = () => {
    const expandedIds = initiativeList.map((initiative) => initiative._id);
    setExpandedNodes((prev) => [...prev, ...expandedIds]);
    getInitiativeStructure(expandedIds);
  };

  const handleCollapse = () => {
    const expandedIds = expandedNodes.filter((node) => !initiativeList.some((initiative) => initiative._id === node));
    setExpandedNodes(expandedIds);
    getInitiativeStructure(expandedIds);
  };

  return (
    <div className='d-flex align-items-center gap-2'>
      <span className='text-ThemeTextMedium'>Expand</span>
      <button onClick={handleExpand} className='fa-light fa-arrows-from-line p-0'></button>
      <button onClick={handleCollapse} className='fa-light fa-arrows-to-line p-0 ms-2'></button>
    </div>
  );
};
